import { Inject, Injectable } from "@angular/core";
import { BaseService } from "./base-service";
import { HttpClient } from "@angular/common/http";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { IAppConfig } from "../lib/config/app-config";
import { Observable } from "rxjs";
import { EventTypes } from "../_models/EventDto";

@Injectable({
  providedIn: "root"
})
export class EventTypeService extends BaseService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "EventType/";
  private static readonly GETALL_EVENT_TYPE: string = "getalleventtypes";

  constructor(
    http: HttpClient,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {
    super(http);
  }

  public getAllEventTypes$(): Observable<EventTypes[]> {
    return this.http.get<EventTypes[]>(
      this.baseUrl + EventTypeService.path + EventTypeService.GETALL_EVENT_TYPE
    );
  }
}